import React, { useEffect, useState } from 'react'
import Header from '../components/layout/Header'
import Footer from '../components/layout/Footer'
import { Link, useNavigate } from 'react-router-dom'
import Service from './../service';
import toast, { Toaster } from 'react-hot-toast';
import MetaHelmet from '../components/metaHelmet';

const api = new Service();
const GarageSales = (props) => {

  const [metaDetail, setMetaDetail] = useState({});
  const [config, setconfig] = useState(props.config)

  const navigate = useNavigate();

  const GetMetaDetail = () => {
    api.getApi('getMetaByPageName', { page_name: '/garage-sales' }).then(response => {
      console.log(response, 'responseName')
      if (response && response.record) {
        console.log(response, 'getting response');
        setMetaDetail(response.record)

      } else {
        // navigate('/404')
      }

    }).catch(error => {
      toast.error(error.message);
    });
  }

  useEffect(() => {
    GetMetaDetail();
  }, []);

  useEffect(() => {
    document.title = metaDetail.meta_title;
    window.gtag('config', config.G_TAG, {
      page_title: metaDetail.meta_title,
      page_path: window.location.pathname,
    });
  }, [metaDetail]);

  const [Active, setActive] = useState([]);
  const [Deactive, setDeactive] = useState([]);

  useEffect(() => {
    getCityList();
  }, [])

  const getCityList = () => {
    api.getApi('location', {}).then(response => {
      if (response.data) {
        setActive(response.data.Active)
        setDeactive(response.data.Deactive)
      }
    }).catch(error => {
      toast.error(error.message);
    });
  }

  return (
    <>  {metaDetail ?
      <MetaHelmet title={metaDetail.meta_title} description={metaDetail.meta_description} />
      : ''}
      <Toaster position="top-right" reverseOrder={false} />
      <Header />
      <div>
        <section className="heroBanner GarageSales">
          <div className="container">
            <div className="row">
              <div className="col-md-12 col-lg-5">
                <br /><br />
                <h1>Garage Sales</h1>
                <h4>ON DEMAND DELIVERY &amp; MOVING</h4>
                <h5>Truck &amp; Muscle Anytime You Need It ™</h5>
                <br /><br /><br />
              </div>
            </div>
          </div>
        </section>
        <section className="about-area">
          <div className="container">
            <div className="row">
              <div className="col-lg-6">
                <div className="mv_aboutus2">
                  <img src="web/img/seo/garage-sale.jpg" alt="affordable-move" className="img-responsive" /></div>
              </div>
              <div className="col-lg-6">
                {/* <div className="about-item-content">
          
            <span>See something you like? </span>
                            <h3>Dont worry about how you are going to get that large or heavy item home.</h3>
                            <p>Found something that you want to take home right away? &nbsp;MoveIt is ready to help you when you need to get your purchase home from garage sales.

                                Garage sales are fun to shop at, Get your great find picked up and delivered right away. 
                                <br /><br />
                                Same day garage sale pickup & delivery.
							<br /><br />
							Truck & Muscle Anytime You Need It ™
							</p> 
          </div> */}
                <div className="about-item-content">

                  <span>Found something that you want to take home right away?<br />
                  </span>
                  <h3 style={{ fontWeight: 500 }}>Move It is ready to help you when you need to get your purchase home from garage sales.
                  </h3>
                  <br />
                  <p>Garage sales are fun to shop at. Get your great find picked up and delivered right away. </p>
                  {/* <br /> */}
                  <p>
                    See something you like?
                  </p>
                  {/* <br /> */}
                  <p>
                    Dont worry about how you are going to get that large or heavy item home.
                  </p>
                  {/* <br /> */}
                  <p>
                    Same day garage sale pickup & delivery.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="service-area lightBgColor">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-6 mb-5 mb-lg-0">
                <div className="position-relative">
                  <img className="w-100" src="web/img/seo/whychoosemoveit.jpeg" alt="about" />
                  <div className="position-absolute bottom left w-100">
                    <img className="svg-injector w-100 ie-h-34" src="web/img/seo/shape-4.png" alt="svg" />
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                {/* Heading Start */}
                <div className="mb-md-6 mb-4">
                  <h2 className="font-weight-bold mb-0">Why Choose Move It</h2>
                  <p className="mb-0">On Demand Delivery and Move Service</p>
                </div>
                {/* Heading End */}
                <div className="row">
                  <div className="col-md-6">
                    <ul className="list-unstyled mb-3 mb-md-0 pt-0">
                      <li className="mb-3">
                        <span className="badge badge-rounded-circle badge-primary-soft mr-2">
                          <i className="fa fa-check" />
                        </span>
                        On Demand Scheduling
                      </li>
                      <li className="mb-3">
                        <span className="badge badge-rounded-circle badge-primary-soft mr-2">
                          <i className="fa fa-check" />
                        </span>
                        Guaranteed Pricing
                      </li>
                      <li>
                        <span className="badge badge-rounded-circle badge-primary-soft mr-2">
                          <i className="fa fa-check" />
                        </span>
                        Quick and Easy
                      </li>
                    </ul>
                  </div>
                  <div className="col-md-6">
                    {/* List Start */}
                    <ul className="list-unstyled mb-0 pt-0">
                      <li className="mb-3">
                        <span className="badge badge-rounded-circle badge-primary-soft mr-2">
                          <i className="fa fa-check" />
                        </span>
                        Customer Reviewed
                      </li>
                      <li className="mb-3">
                        <span className="badge badge-rounded-circle badge-primary-soft mr-2">
                          <i className="fa fa-check" />
                        </span>
                        You are Protected
                      </li>
                      <li>
                        <span className="badge badge-rounded-circle badge-primary-soft mr-2">
                          <i className="fa fa-check" />
                        </span>
                        Superior Service
                      </li>
                    </ul>
                    {/* List End */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="service-area bgWhite">
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center">
                <span>Move It Job</span>
                <h2>How to book</h2>
              </div>
            </div>
            <div className="row align-item-center justify-content-center hidetimeline-section">
              <div className="col-md-12 col-lg-12">
                <div className="swiper swiper-initialized swiper-horizontal swiper-pointer-events timeline-slide swiper-backface-hidden">
                  <div className="swiper-wrapper">
                    <div className="swiper-slide swiper-slide-active"><h4 className="title">01</h4><h5 className="sub-title">Enter Your Details</h5><p className="content">Tell us when, where, and what you need delivered or moved</p></div>
                    <div className="swiper-slide swiper-slide-next"><h4 className="title">02</h4><h5 className="sub-title">Get Your Guaranteed Price</h5><p className="content">Select how many helpers you need and get an instant price quote.</p></div>
                    <div className="swiper-slide"><h4 className="title">03</h4><h5 className="sub-title">Book Your Move It Pros and/or Muscles</h5><p className="content">Get connected to and scheduled with Move It Pros and Muscles right away..</p></div>
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="row d-flex showtimeline-section">
        <div className="col-md-12">
          <div className="history-tl-container">
            <ul className="tl">
              <li className="tl-item" ng-repeat="item in retailer_history">
                <div className="item-title">Enter Your Details</div>
                <div className="item-detail">Tell us when, where, and what you need delivered or moved</div>
              </li>
              <li className="tl-item" ng-repeat="item in retailer_history">
                <div className="item-title">Get Your Guaranteed Price</div>
                <div className="item-detail">Select how many helpers you need and get an instant price quote.</div>
              </li>
              <li className="tl-item" ng-repeat="item in retailer_history">
                <div className="item-title">Book Your MoveIt Pros and/or Muscles</div>
                <div className="item-detail">Get connected to and scheduled with MoveIt Pros and Muscles right away.</div>
              </li>
            </ul>
          </div>
        </div>
      </div> */}
          </div>
        </section>
        <section className="about-area lightBgColor">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="about-item-content">
                  <span>Move It</span>
                  <h2>Other Services Provided</h2>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-3">
                <ul className="otherService">
                  <li><Link to="/donate-furniture">Donate Furniture</Link></li>
                  <li><Link to="/uber-for-moving">Uber For Moving</Link></li>
                  <li><Link to="/same-day-junk-removal">Same Day Junk Removal</Link></li>
                  <li><Link to="/apartment-move">Apartment Move</Link></li>
                  <li><Link to="/move-without-car">Move Without Car</Link></li>
                  <li><Link to="/rent-pickup-truck-for-moving">Rent Pickup Truck For Moving</Link></li>
                  <li><Link to="/small-business-move">Small Business Move</Link></li>
                  <li><Link to="/costco-delivery">Costco Delivery</Link></li>
                </ul>
              </div>
              <div className="col-lg-3">
                <ul className="otherService">
                  <li><Link to="/delivery-service-app">Delivery Service App</Link></li>
                  {/* <li><Link to="/couch-moving">Couch Moving</Link></li> */}
                  <li><Link to="/moving-help">Moving Help</Link></li>
                  <li><Link to="/couch-moving">Couch Moving Service</Link></li>
                  {/* <li><Link to="/refrigerator-mover">Refrigerator Mover</Link></li> */}
                  {/* <li><Link to="/fast-delivery">Fast Delivery</Link></li> */}
                  <li><Link to="/furniture-delivery">Furniture Delivery</Link></li>
                  <li><Link to="/direct-store-delivery">Direct Store Delivery</Link></li>
                  <li><Link to="/on-demand-delivery">On Demand Delivery</Link></li>
                  <li><Link to="/sams-club-delivery">Sam's Club Delivery</Link></li>
                  <li><Link to="/truck-loading-and-unloading">Truck Loading/Unloading</Link></li>
                </ul>
              </div>
              <div className="col-lg-3">
                <ul className="otherService">
                  {/* <li><Link to="/hardware-delivery">Hardware Delivery</Link></li> */}
                  <li><Link to="/move-washer-and-dryer">Move Washer &amp; Dryer</Link></li>
                  {/* <li><Link to="/moving-alone">Moving Alone</Link></li> */}
                  <li><Link to="/lumber-hauling-and-delivery">Lumber Hauling &amp; Delivery</Link></li>
                  <li><Link to="/last-mile-delivery">Last Mile Delivery</Link></li>
                  <li><Link to="/appliance-delivery">Appliance Delivery</Link></li>
                  <li><Link to="/assisted-living-movers-senior-moving">Assisted Senior Moving</Link></li>
                  <li><Link to="/local-delivery">Local Delivery</Link></li>
                  <li><Link to="/college-dorm-moving">College Dorm Moving</Link></li>
                  <li><Link to="/last-minute-movers">Last Minute Movers</Link></li>
                </ul>
              </div>
              <div className="col-lg-3">
                <ul className="otherService">
                  <li><Link to="/christmas-tree-delivery">Christmas Tree Delivery</Link></li>
                  <li><Link to="/christmas-tree-recycle">Christmas Tree Recycle</Link></li>
                  <li><Link to="/affordable-moving">Affordable Moving</Link></li>
                  <li><Link to="/used-item-delivery">Used Item Delivery</Link></li>
                  <li><Link to="/estate-sales">Estate Sales</Link></li>
                  <li><Link to="/garage-sales">Garage Sales</Link></li>
                  <li><Link to="/moving-pods">Moving PODS &amp; Portable Storage Loading Help</Link></li>
                </ul>
              </div>
            </div>
          </div>
        </section>
        <section className="cityAvaible">
          <div className="container">
            <div className="row">
              <div className="col-md-8 ">
                <div className="live__map_wrap">


                  <Link to="" className="loc_map-mark" data-id="" title="Denver, CO" style={{ top: "40%", left: "32.5%" }}>
                    <img src="web/img/google-maps.svg" data-src="web/img/google-maps.svg" alt="" />
                    <div className='pulse'></div>
                  </Link>
                  <Link to="" className="loc_map-mark" data-id="" title="Las Vegas, NV" style={{ top: "49%", left: "13.5%" }}>
                    <img src="web/img/google-maps.svg" data-src="web/img/google-maps.svg" alt="" />
                    <div className='pulse'></div>
                  </Link>
                  <Link to="" className="loc_map-mark sandngo" data-id="" title="San Diego, CA" style={{ top: "57%", left: "7.9%" }}>
                    <img src="web/img/google-maps.svg" data-src="web/img/google-maps.svg" alt="" />
                    <div className='pulse'></div>
                  </Link>
                  <Link to="" className="loc_map-mark" data-id="" title="Tucson, AZ" style={{ top: "60%", left: "20%" }}>
                    <img src="web/img/google-maps.svg" data-src="web/img/google-maps.svg" alt="" />
                    <div className='pulse'></div>
                  </Link>
                  <Link to="" className="loc_map-mark" data-id="" title="Phoenix, AZ" style={{ top: "58%", left: "19.5%" }}>
                    <img src="web/img/google-maps.svg" data-src="web/img/google-maps.svg" alt="" />
                    <div className='pulse'></div>
                  </Link>



                  <Link to="" className="loc_map-mark" data-id="" title="Albuquerque" style={{ top: "47%", left: "25.5%" }}>
                    <img src="web/img/map-pin1.svg" data-src="web/img/map-pin1.svg" alt="" style={{ width: "15px" }} />
                  </Link>
                  <Link to="" className="loc_map-mark" data-id="" title="Salt Lake City, UT" style={{ top: "26%", left: "23.5%" }}>
                    <img src="web/img/map-pin1.svg" data-src="web/img/map-pin1.svg" alt="" style={{ width: "15px" }} />
                  </Link>

                  <Link to="" className="loc_map-mark" data-id="" title="Austin, TX" style={{ top: "70%", left: "47%" }}>
                    <img src="web/img/map-pin1.svg" data-src="web/img/map-pin1.svg" alt="" style={{ width: "15px" }} />
                  </Link>
                  <Link to="" className="loc_map-mark" data-id="" title="Dallas, TX" style={{ top: "66%", left: "47%" }}>
                    <img src="web/img/map-pin1.svg" data-src="web/img/map-pin1.svg" alt="" style={{ width: "15px" }} />
                  </Link>
                  <Link to="" className="loc_map-mark" data-id="" title="San Jose, CA" style={{ top: "38%", left: "1%" }}>
                    <img src="web/img/map-pin1.svg" data-src="web/img/map-pin1.svg" alt="" style={{ width: "15px" }} />
                  </Link>


                  <Link to="" className="loc_map-mark" data-id="" title="Los Angeles, CA" style={{ top: "51%", left: "4.5%" }}>
                    <img src="web/img/map-pin1.svg" data-src="web/img/map-pin1.svg" alt="" style={{ width: "15px" }} />
                  </Link>
                  <Link to="" className="loc_map-mark m-bile" data-id="" title="Seattle, WA" style={{ top: "8%", left: "7%" }}>
                    <img src="web/img/map-pin1.svg" data-src="web/img/map-pin1.svg" alt="" style={{ width: "15px" }} />
                  </Link>
                  <Link to="" className="loc_map-mark" data-id="" title="Chicago, IL" style={{ top: "33%", left: "64.5%" }}>
                    <img src="web/img/map-pin1.svg" data-src="web/img/map-pin1.svg" alt="" style={{ width: "15px" }} />
                  </Link>
                  <Link to="" className="loc_map-mark" data-id="" title="Houston, TX" style={{ top: "71.5%", left: "52.4%" }}>
                    <img src="web/img/map-pin1.svg" data-src="web/img/map-pin1.svg" alt="" style={{ width: "15px" }} />
                  </Link>

                  <Link to="" className="loc_map-mark" data-id="" title="Atlanta, GA" style={{ top: "57%", left: "73.5%" }}>
                    <img src="web/img/map-pin1.svg" data-src="web/img/map-pin1.svg" alt="" style={{ width: "15px" }} />
                  </Link>
                  <Link to="" className="loc_map-mark mia-bile" data-id="" title="Miami, FL" style={{ top: "81%", left: "84%" }}>
                    <img src="web/img/map-pin1.svg" data-src="web/img/map-pin1.svg" alt="" style={{ width: "15px" }} />
                  </Link>
                  <Link to="" className="loc_map-mark" data-id="" title="San Francisco, CA" style={{ top: "36%", left: "0%" }}>
                    <img src="web/img/map-pin1.svg" data-src="web/img/map-pin1.svg" alt="" style={{ width: "15px" }} />
                  </Link>
                  <Link to="" className="loc_map-mark" data-id="" title="Boston, MA" style={{ top: "23.5%", left: "93.5%" }}>
                    <img src="web/img/map-pin1.svg" data-src="web/img/map-pin1.svg" alt="" style={{ width: "15px" }} />
                  </Link>
                  <Link to="" className="loc_map-mark" data-id="" title="New York, NY" style={{ top: " 28%", left: "89%" }}>
                    <img src="web/img/map-pin1.svg" data-src="web/img/map-pin1.svg" alt="" style={{ width: "15px" }} />
                  </Link>
                  <Link to="" className="loc_map-mark" data-id="" title="Long Island, NY" style={{ top: " 28%", left: "93%" }}>
                    <img src="web/img/google-maps.svg" data-src="web/img/google-maps.svg" alt="" />
                    <div className='pulse'></div>
                  </Link>
                  <Link to="" className="loc_map-mark" data-id="" title="Nashville, TN" style={{ top: "51.25%", left: "68%" }}>
                    <img src="web/img/map-pin1.svg" data-src="web/img/map-pin1.svg" alt="" style={{ width: "15px" }} />
                  </Link>
                  <Link to="" className="loc_map-mark" data-id="" title="Dallas, TX" style={{ top: "66%", left: "47%" }}>
                    <img src="web/img/map-pin1.svg" data-src="web/img/map-pin1.svg" alt="" style={{ width: "15px" }} />
                  </Link>
                  <Link to="" className="loc_map-mark" data-id="" title="Charlotte, NC" style={{ top: "52.5%", left: "80%" }}>
                    <img src="web/img/map-pin1.svg" data-src="web/img/map-pin1.svg" alt="" style={{ width: "15px" }} />
                  </Link>
                  <Link to="" className="loc_map-mark" data-id="" title="Indianapolis, IN" style={{ top: "39.65%", left: "68%" }}>
                    <img src="web/img/map-pin1.svg" data-src="web/img/map-pin1.svg" alt="" style={{ width: "15px" }} />
                  </Link>
                  <Link to="" className="loc_map-mark" data-id="" title="St. Louis, MO" style={{ top: "41.65%", left: "58%" }}>
                    <img src="web/img/map-pin1.svg" data-src="web/img/map-pin1.svg" alt="" style={{ width: "15px" }} />
                  </Link>
                  <Link to="" className="loc_map-mark" data-id="" title="Orange County, CA" style={{ top: "52.5%", left: "6.5%" }}>
                    <img src="web/img/map-pin1.svg" data-src="web/img/map-pin1.svg" alt="" style={{ width: "15px" }} />
                  </Link>
                  <Link to="" className="loc_map-mark" data-id="" title="Cleveland, OH" style={{ top: "33.5%", left: "75%" }}>
                    <img src="web/img/map-pin1.svg" data-src="web/img/map-pin1.svg" alt="" style={{ width: "15px" }} />
                  </Link>
                  <Link to="" className="loc_map-mark" data-id="" title="Minneapolis, MN" style={{ top: "23.5%", left: "54.5%" }}>
                    <img src="web/img/map-pin1.svg" data-src="web/img/map-pin1.svg" alt="" style={{ width: "15px" }} />
                  </Link>
                  <Link to="" className="loc_map-mark" data-id="" title="Philadelphia, PA" style={{ top: "34%", left: "87.2%" }}>
                    <img src="web/img/map-pin1.svg" data-src="web/img/map-pin1.svg" alt="" style={{ width: "15px" }} />
                  </Link>
                  <Link to="" className="loc_map-mark" data-id="" title="Kansas City, MO" style={{ top: "40.65%", left: "50%" }}>
                    <img src="web/img/map-pin1.svg" data-src="web/img/map-pin1.svg" alt="" style={{ width: "15px" }} />
                  </Link>
                  <Link to="" className="loc_map-mark" data-id="" title="Boise, ID" style={{ top: "19%", left: "13%" }}>
                    <img src="web/img/map-pin1.svg" data-src="web/img/map-pin1.svg" alt="" style={{ width: "15px" }} />
                  </Link>

                  <Link to="" className="loc_map-mark" data-id="" title="Little Rock, AR" style={{ top: "51.65%", left: "53%" }}>
                    <img src="web/img/map-pin1.svg" data-src="web/img/map-pin1.svg" alt="" style={{ width: "15px" }} />
                  </Link>

                  <img className="map_img" src="web/img/old-moveit-map.svg" data-src="web/img/old-moveit-map.svg" alt="" />

                </div>

              </div>
              <div className="col-md-4">
                <div className="servingbox newtop">
                  <img src="web/img/google-maps.svg" alt="" /> <span className="f-26"> Available Now </span>
                  <ul className="citylist">
                    {Active.length > 0 && Active.map((option, index) => (
                      <li key={index}>
                        {config.PRODUCTION_MODE ?
                          <>
                            <Link to={option.location_name_alias}>{option.name}</Link>
                          </>
                          : option.name}
                      </li>
                    ))}

                  </ul>


                </div>
              </div>
            </div>
          </div>
        </section>
        <Link className="section red padd-50" to>
          <article className="text-center">
            <h6 className="h2">Still have  <strong> questions? </strong></h6>
            <span className="button outline inverse">Contact Us <i className="fa fa-chevron-right" /></span>
          </article>
        </Link>
      </div>
      <Footer />

    </>
  )
}

export default GarageSales


